
import { IContextualMenuProps } from '@fluentui/react';
import { exportMessagesToPPTX } from '../pptxExport/exporter';
import { BotResponse } from '../api'
import { getAllMessagesHTML, getSelectedMessagesHTML } from './exportUtils';

export const handleDownloadSelectedClick = async (
  messages: BotResponse[],
  messageId: string | undefined,
  setIsBlinking: (value: boolean) => void
): Promise<void> => {
  setIsBlinking(true);
  const messagesHTML = getSelectedMessagesHTML(messages, messageId);
  await exportMessagesToPPTX(messagesHTML);
  setIsBlinking(false);
};

export const handleDownloadAllClick = async (
  messages: BotResponse[],
  messageId: string | undefined,
  setIsBlinking: (value: boolean) => void
): Promise<void> => {
  setIsBlinking(true);
  const messagesHTML = getAllMessagesHTML(messages, messageId);
  await exportMessagesToPPTX(messagesHTML);
  setIsBlinking(false);
};

export const exportOptions = (
  messages: BotResponse[],
  answer: { message_id?: string },
  setIsBlinking: (value: boolean) => void
): IContextualMenuProps => ({
  items: [
    {
      key: 'pptx',
      text: 'Export to PPTX',
      subMenuProps: {
        items: [
          {
            key: 'all',
            text: 'Export all to PPTX',
            onClick: () => {
              handleDownloadAllClick(messages, answer.message_id, setIsBlinking);
              return true;
            },
          },
          {
            key: 'selected',
            text: 'Export selected to PPTX',
            onClick: () => {
              handleDownloadSelectedClick(messages, answer.message_id, setIsBlinking);
              return true;
            },
          },
        ],
      },
    },
  ],
});
